















































































































import { Component, Vue, Watch, PropSync, Prop } from "vue-property-decorator";
// import { decorationData, questionData, testData, QuestionDataType } from "../../config/questionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";

@Component({
  name: "logicSet",
  components: {},
  filters: {},
})
export default class QuestionnaireEdit extends Vue {
  @PropSync("modalVisible", { type: Boolean }) visible!: Boolean;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;
  @Watch("visible")
  inputValChange(val: any) {
    if (val) {
      // this.findRewardingActivity();
      this.initIfItems();
      this.initPostForm();
    }
  }
  ifItems: any = [];
  noneDecoItems: any = [];
  private localSubmit = {};
  private postForm: any = {
    itemShowLogics: [],
  };

  // private rules = {
  //   title: [{ required: true, type: "string", message: "请填写标题", trigger: "blur" }],
  // };

  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get dataList() {
    return QuestionnaireEditModule.dataList;
  }
  get formLogicConfig() {
    return QuestionnaireEditModule.formLogicConfig;
  }

  private uniqueArr = [25, 26, 27, 28, 29];

  deleteLogic(index: number) {
    this.postForm.itemShowLogics.splice(index, 1);
  }
  addLogic() {
    //
    this.postForm.itemShowLogics.push({
      nextItem: [],
      itemOptions: [],
      thenEffect: "",
      operate: "",
      ifItem: "",
      ifItemIndex: "",
      ifItemIsRadio: false,
      ifItemOptions: [],
    });
  }
  ifItemChange(value: any, index: any) {
    console.log("ifItemChange", value, index);
    if (value) {
      let oifItemIndex: any = this.noneDecoItems.findIndex((item: any) => {
        return item.data.id == value;
      });
      if (oifItemIndex >= 0) {
        this.postForm.itemShowLogics[index].ifItemIndex = oifItemIndex;
        const oifItem: any = this.noneDecoItems[oifItemIndex];
        this.postForm.itemShowLogics[index].itemOptions = [];
        this.postForm.itemShowLogics[index].nextItem = [];
        this.postForm.itemShowLogics[index].ifItemOptions = oifItem.data.optionsList;
        this.postForm.itemShowLogics[index].ifItemIsRadio = oifItem.data.type == 1 || oifItem.data.type == 9;
      }
    }
  }
  thenEffectChange(value: any, index: any) {
    if (value == "HIDEALL") {
      this.postForm.itemShowLogics[index].nextItem = [];
    }
  }
  validateIfItem(rule: any, value: string, callback: any) {
    let ifitemExist = this.noneDecoItems.some((nitem: any) => {
      return nitem.data.id == value;
    });
    if (!ifitemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
  validateItemOptions(rule: any, value: any, callback: any) {
    let logicIndex = rule.field.split(".")[1];
    let ifItemOptions = this.postForm.itemShowLogics[logicIndex].ifItemOptions;
    const itemExist = value.every((id: string) => {
      return ifItemOptions.some((op: any) => {
        return op.id == id;
      });
    });
    if (!itemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
  // validateItemOption(rule: any, value: Array<string>, callback: any) {
  //   let sameLogic = this.postForm.itemShowLogics.filter((item: any) => {
  //     return item.itemOptions.sort().toString() == value.sort().toString();
  //   });

  //   if (sameLogic.length > 1) {
  //     callback(new Error("操作项目已失效 请重选"));
  //   } else {
  //     callback();
  //   }
  // }
  validateNextItem(rule: any, value: Array<string>, callback: any) {
    // let sameLogic = this.postForm.itemShowLogics.filter((item: any) => {
    //   return item.nextItem == value;
    // });

    // if (sameLogic.length > 1) {
    //   callback(new Error("与已有逻辑冲突，请重新设置"));
    // } else {
    // console.log("validateNextItem", rule.field);
    if (rule.field) {
      let logicIndex = rule.field.split(".")[1];
      let findEmpty = value.some((id: any) => {
        return !this.noneDecoItems.some((nitem: any) => {
          return nitem.data.id == id;
        });
      });
      if (findEmpty) {
        return callback(Error("操作项目已失效 请重选"));
      }
      let findWrongSort = value.some((id: any) => {
        let nextIndex = this.noneDecoItems.findIndex((nitem: any) => {
          return nitem.data.id == id;
        });
        return nextIndex <= this.postForm.itemShowLogics[logicIndex].ifItemIndex;
      });
      if (findWrongSort) {
        return callback(Error("排序已失效"));
      }

      return callback();
    }
    // }
  }
  initIfItems() {
    let dataList = JSON.parse(JSON.stringify(this.dataList));

    this.noneDecoItems = dataList.filter((item: any) => {
      return ![15, 16, 5, 8, 24].includes(item.componentName);
    });
    this.noneDecoItems.forEach((item: any, index: string) => {
      item.index = index + 1;
    });
    this.ifItems = dataList.filter((item: any) => {
      return [1, 2, 9, 10, 27].includes(item.componentName);
    });
    // this.ifItems.forEach((item: any) => {
    //   item.index =
    //     this.noneDecoItems.findIndex((item: any) => {
    //       return item.data.id == item.data.id;
    //     }) + 1;
    // });
  }
  getFormInstance() {
    return this.$refs.postForm as any;
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }

  initPostForm() {
    let postForm = JSON.parse(JSON.stringify(this.formLogicConfig));
    postForm.itemShowLogics.forEach((logic: any) => {
      if (logic.ifItem) {
        let oifItemIndex: any = this.noneDecoItems.findIndex((item: any) => {
          return item.data.id == logic.ifItem;
        });
        if (oifItemIndex >= 0) {
          logic.ifItemIndex = oifItemIndex;
          logic.ifItemOptions = (this.noneDecoItems[oifItemIndex] as any).data.optionsList;
        } else {
          logic.ifItemIndex = 0;
          logic.ifItemOptions = [];
        }
      } else {
        logic.ifItemIndex = 0;
        logic.ifItemOptions = [];
      }
    });
    this.postForm = postForm;
  }

  // $ handleModules

  getModulesConfigInstance() {
    return this.$refs.modulesConfig as any;
  }

  getSubmitConfigInstance() {
    return this.$refs.submitConfig as any;
  }
  async validateForSave() {
    // 保存总配置时,用来最终效验有没有失效项目
    this.clearValidate();

    console.log("logicSetvalidateForSave");
    this.initIfItems();
    this.initPostForm();
    return await this.validate();
  }
  async validate() {
    if (this.postForm.itemShowLogics.length == 0) {
      QuestionnaireEditModule.SET_FORM_LOGIC_CONFIG(this.postForm);
      return true;
    }
    if (!this.getFormInstance()) {
      this.visible = true;
      return false;
    }
    let result = await this.getFormInstance()
      .validate()
      .catch(() => {
        return false;
      });
    console.log("itemShowLogicsValidate", result);
    if (result) {
      QuestionnaireEditModule.SET_FORM_LOGIC_CONFIG(this.postForm);
    }
    return result;
  }
  closeDialog() {
    this.initPostForm();
    this.visible = false;
  }
  async handleCommit() {
    let vali = await this.validate();
    console.log("validate", vali);
    if (vali) {
      this.visible = false;
    }
  }
}
